import {
  Companion_instance1x10wxdaspp9d as Companion_instance,
  LockInfo3qyh26jodrlpf as LockInfo,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { AccessInfoj60d6hx1qs8r as AccessInfo } from './supportModels.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareLockInfoFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [LockInfo_access_getInstance(), LockInfo_clientLocked_getInstance()];
  var tmp = Companion_instance.m2a();
  properties(tmp, (it) => props);
}
function LockInfo_access$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(0);
}
function LockInfo_access$_get_name_$ref_kg182x() {
  return (p0) => p0.k20();
}
function LockInfo_access$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LockInfo_access$_get_serializer_$ref_kg8k02() {
  return (p0) => p0.j2j();
}
function LockInfo_access$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(0);
}
function LockInfo_access$_get_annotations_$ref_lecc8u() {
  return (p0) => p0.bz();
}
var LockInfo_accessClass;
function LockInfo_access() {
  if (LockInfo_accessClass === VOID) {
    class $ {
      constructor() {
        LockInfo_access_instance = this;
        var tmp = this;
        tmp.m6q_1 = lazy(LockInfo_access$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n6q_1 = lazy(LockInfo_access$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o6q_1 = lazy(LockInfo_access$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LockInfo_access$_get_name_$ref_kg182x(), null);
        return tmp0.f2();
      }
      p6q(receiver) {
        return receiver.q6q_1;
      }
      m2j(receiver) {
        return this.p6q(receiver instanceof LockInfo() ? receiver : THROW_CCE());
      }
      s6q(receiver, value) {
        return receiver.t6q(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof LockInfo() ? receiver : THROW_CCE();
        return this.s6q(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LockInfo_access$_get_serializer_$ref_kg8k02(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LockInfo_access$_get_annotations_$ref_lecc8u(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'LockInfo_access', VOID, VOID, [SerializableProperty()]);
    LockInfo_accessClass = $;
  }
  return LockInfo_accessClass;
}
var LockInfo_access_instance;
function LockInfo_access_getInstance() {
  if (LockInfo_access_instance === VOID)
    new (LockInfo_access())();
  return LockInfo_access_instance;
}
function LockInfo_clientLocked$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(1);
}
function LockInfo_clientLocked$_get_name_$ref_e1516g() {
  return (p0) => p0.k20();
}
function LockInfo_clientLocked$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LockInfo_clientLocked$_get_serializer_$ref_ulh4pd() {
  return (p0) => p0.j2j();
}
function LockInfo_clientLocked$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(1);
}
function LockInfo_clientLocked$_get_annotations_$ref_8zl9n7() {
  return (p0) => p0.bz();
}
var LockInfo_clientLockedClass;
function LockInfo_clientLocked() {
  if (LockInfo_clientLockedClass === VOID) {
    class $ {
      constructor() {
        LockInfo_clientLocked_instance = this;
        var tmp = this;
        tmp.u6q_1 = lazy(LockInfo_clientLocked$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v6q_1 = lazy(LockInfo_clientLocked$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w6q_1 = lazy(LockInfo_clientLocked$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LockInfo_clientLocked$_get_name_$ref_e1516g(), null);
        return tmp0.f2();
      }
      p6q(receiver) {
        return receiver.r6q_1;
      }
      m2j(receiver) {
        return this.p6q(receiver instanceof LockInfo() ? receiver : THROW_CCE());
      }
      x6q(receiver, value) {
        return receiver.t6q(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof LockInfo() ? receiver : THROW_CCE();
        return this.x6q(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LockInfo_clientLocked$_get_serializer_$ref_ulh4pd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LockInfo_clientLocked$_get_annotations_$ref_8zl9n7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'LockInfo_clientLocked', VOID, VOID, [SerializableProperty()]);
    LockInfo_clientLockedClass = $;
  }
  return LockInfo_clientLockedClass;
}
var LockInfo_clientLocked_instance;
function LockInfo_clientLocked_getInstance() {
  if (LockInfo_clientLocked_instance === VOID)
    new (LockInfo_clientLocked())();
  return LockInfo_clientLocked_instance;
}
//region block: exports
export {
  prepareLockInfoFields as prepareLockInfoFields1slwxs30de1hf,
};
//endregion

//# sourceMappingURL=LockInfoFields.mjs.map
